import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from './contexts/AuthContext';
import Layout from './template/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';

import Branch from './pages/Masters/Branch';
import ExpenditureType from './pages/Masters/ExpenditureType';
import Role from './pages/Masters/Role';
import Vendor from './pages/PartnerManagement/Vendor';
import Client from './pages/PartnerManagement/Client'; // Import the new Client component
import Project from './pages/ProjectManagement/Project';
import ProjectDetails from './pages/ProjectManagement/ProjectDetails';
import ProjectEstimates from './pages/ProjectManagement/ProjectEstimates';
import ProjectSchedule from './pages/ProjectManagement/ProjectSchedule';
import ProjectTeam from './pages/ProjectManagement/ProjectTeam';
import ProjectTeamSchedule from './pages/ProjectManagement/ProjectTeamSchedule';
import Member from './pages/Team/Member';
import Staff from './pages/Team/Staff';
import PayIn from './pages/Transactions/PayIn';
import Payout from './pages/Transactions/Payout';
import PettyCash from './pages/Transactions/PettyCash';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/cpnl/*" element={<Layout />}>
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="branch" element={<Branch />} />
            <Route path="expenditure-type" element={<ExpenditureType />} />
            <Route path="role" element={<Role />} />
            <Route path="vendor" element={<Vendor />} />
            <Route path="client" element={<Client />} />
            <Route path="project" element={<Project />} />
            <Route path="project-details/:id" element={<ProjectDetails />} />
            <Route path="project-estimates" element={<ProjectEstimates />} />
            <Route path="project-schedule" element={<ProjectSchedule />} />
            <Route path="project-team" element={<ProjectTeam />} />
            <Route path="project-team-schedule" element={<ProjectTeamSchedule />} />
            <Route path="pay-in" element={<PayIn />} />
            <Route path="pay-out" element={<Payout />} />
            <Route path="petty-cash" element={<PettyCash />} />
            <Route path="member" element={<Member />} />
            <Route path="staff" element={<Staff />} />
            {/* Add your sub-routes here */}
            {/* {MasterRoutes} */}
            {/* Projects */}
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
